import type { FormField } from './types';

/** Image/Table/List/DocumentDictionary bound to a `source: service` config, or the standalone
 * ServiceLookup/AIText types — a value the wizard has no input control for at all, since
 * RunServiceLookupsStep always resolves it fresh at generation time regardless of what (if
 * anything) was submitted. Required-ness must not be checked against wizard.values for these. */
const SOURCEABLE_TYPES = new Set(['Image', 'Table', 'List', 'DocumentDictionary']);
const ALWAYS_SERVICE_TYPES = new Set(['ServiceLookup', 'AIText']);

export function isServiceProvided(field: Pick<FormField, 'propertyType' | 'configJson'>): boolean {
  if (ALWAYS_SERVICE_TYPES.has(field.propertyType)) return true;
  if (!SOURCEABLE_TYPES.has(field.propertyType)) return false;

  try {
    const parsed = JSON.parse(field.configJson || '{}') as { source?: unknown };
    return parsed.source === 'service';
  } catch {
    return false;
  }
}
